// src/pages/Admin/PasswordReset.jsx
import React, { useState } from "react";
import axios from "axios";

export default function PasswordReset() {
  const [phone, setPhone] = useState("");
  const [user, setUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const searchUser = async () => {
    if (!phone) return;
    setLoading(true);
    setMessage("");
    setUser(null);

    try {
      const res = await axios.get(
        `https://api.earnmoney0.top/admin/find-user/${phone}`
      );

      if (res.data.success) {
        setUser(res.data.user);
      } else {
        setMessage("❌ User not found");
      }
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    if (!newPassword) return;

    try {
      const res = await axios.post(
        `https://api.earnmoney0.top/admin/reset-password`,
        { phone, newPassword }
      );

      if (res.data.success) {
        setMessage("✅ Password Reset Complete");
        setNewPassword("");
      } else {
        setMessage("❌ Reset failed");
      }
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Something went wrong!");
    }
  };

  return (
    <div className="reset-page">
      <style>{`
        .reset-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }

        h1 {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 24px;
          color: #22c55e;
        }

        .search-container {
          display: flex;
          gap: 8px;
          margin-bottom: 24px;
        }

        .search-container input {
          flex: 1;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #444;
          background: #111827;
          color: white;
          font-size: 16px;
        }

        .search-container button {
          padding: 10px 16px;
          border: none;
          border-radius: 8px;
          background: #22c55e;
          color: black;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .search-container button:hover {
          background: #16a34a;
        }

        .user-card {
          background: #111827;
          padding: 20px;
          border-radius: 16px;
          max-width: 600px;
          margin-top: 16px;
        }

        .user-card div {
          margin-bottom: 14px;
        }

        .label {
          font-weight: 600;
          color: #facc15;
          width: 180px;
          display: inline-block;
        }

        .value {
          font-weight: 500;
          color: #ffffff;
        }

        .reset-box {
          margin-top: 20px;
          display: flex;
          gap: 8px;
        }

        .reset-box input {
          flex: 1;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #444;
          background: #0f172a;
          color: white;
        }

        .reset-box button {
          padding: 10px 16px;
          background: #ef4444;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          color: white;
          transition: 0.3s;
        }

        .reset-box button:hover {
          background: #dc2626;
        }

        .message-success {
          color: #22c55e;
          font-weight: 600;
          margin-top: 12px;
        }

        .message-error {
          color: #f87171;
          font-weight: 600;
          margin-top: 12px;
        }

        @media (max-width: 640px) {
          .user-card {
            max-width: 100%;
          }
          .label {
            width: 140px;
          }
          h1 {
            font-size: 22px;
          }
        }
      `}</style>

      <h1>🔐 Reset User Password</h1>

      <div className="search-container">
        <input
          type="text"
          placeholder="Enter Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <button onClick={searchUser} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {message && !user && (
        <p className="message-error">{message}</p>
      )}

      {user && (
        <div className="user-card">
          <div>
            <span className="label">Username:</span>
            <span className="value">{user.name}</span>
          </div>

          <div>
            <span className="label">Phone:</span>
            <span className="value">{user.phone}</span>
          </div>

          <div className="reset-box">
            <input
              type="text"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button onClick={resetPassword}>
              Reset
            </button>
          </div>

          {message && (
            <p
              className={
                message.includes("Complete")
                  ? "message-success"
                  : "message-error"
              }
            >
              {message}
            </p>
          )}
        </div>
      )}
    </div>
  );
}